import type { Category } from './vault/vaultData'

/**
 * What the Library pages remember per account for this browser session, so a
 * re-open shows the last state at once while OnlyFans is asked again. (The
 * lists' first pages themselves are kept by usePagedList.)
 */
export const pageMemory = {
  /** Vault: the All media row. */
  vaultAll: new Map<string, Category>(),
  /** Collections: the list last open. */
  openList: new Map<string, string>(),
  /** Collections: /v1/subscriptions/count. */
  subscriptionCounts: new Map<string, Record<string, unknown>>(),
}

/** Forget everything remembered (tests). */
export function clearPageMemory() {
  for (const m of Object.values(pageMemory)) m.clear()
}
